module.exports = __webpack_public_path__ + "static/media/case-id-tooltip-es.718adaed.jpg";